export function sync_query_params(params, new_query) {
	for (const key in params) {
		if (!params.hasOwnProperty(key)) {
			continue;
		}

		if (new_query.hasOwnProperty(key)) {
			continue;
		}

		delete params[key];
	}

	Object.assign(params, new_query);
}

export function get_image_url(template, item) {
	if (!item) {
		return;
	}

	if (item.company_logo) {
		return item.company_logo;
	}

	if (!template) {
		return;
	}

	if (!item.company_domain) {
		return;
	}

	return template.replace(`:domain`, item.company_domain);
}
